<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong> Anomalies SIREN et NIC (contrats ouverts) </strong>
      </b-card-header>
      <b-card-body>
        
        <h6 class="d-inline-block">Anomalie SIREN</h6>
        <vue-excel-xlsx
          :data="excelDataSiren"
          :columns="excelColumns"
          class="export-excel-btn ml-2 mb-1"
          :filename="'export_anomalies_siren_'+getTimestamp()">
          <i class="fa fa-file-excel-o"></i>&nbsp; Exporter Anomalie SIREN en Excel
        </vue-excel-xlsx>
        <table class="mb-2" border="1px">
          <thead>
          <tr>
            <td class="prune-medium center p-1" width="75"><b>NumPM</b></td>
            <td class="prune-medium p-1" width="80"><b>Type Ano.</b></td>
            <td class="prune-medium center p-1" width="85"><b>SIREN</b></td>
            <td class="prune-medium center p-1" width="60"><b>NIC</b></td>
            <td class="prune-medium p-1" width="600"><b>Nom du Site</b></td>
            <td class="prune-medium center p-1" width="75"><b>CntColl</b></td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(element, key) in anomalieSiren" :key="key">
            <td class="center p-1"> {{ element.num_pm }}</td>
            <td class="center p-1"> {{ element.type_anomalie }}</td>
            <td class="center p-1"> {{ element.siren }}</td>
            <td class="center p-1"> {{ element.nic }}</td>
            <td class="p-1"> {{ element.raison_sociale }}</td>
            <td class="center p-1"> {{ element.precision }}</td>
          </tr>
          </tbody>
        </table>
        
        <h6 class="mt-3 d-inline-block">Anomalie NIC</h6>
        <vue-excel-xlsx
          :data="excelDataNic"
          :columns="excelColumns"
          class="export-excel-btn mb-1 ml-2"
          :filename="'export_anomalies_nic_'+getTimestamp()">
          <i class="fa fa-file-excel-o"></i>&nbsp; Exporter Anomalie NIC en Excel
        </vue-excel-xlsx>
        <table class="" border="1px">
          <thead>
          <tr>
            <td class="prune-medium center p-1" width="75"><b>NumPM</b></td>
            <td class="prune-medium p-1" width="80"><b>Type Ano.</b></td>
            <td class="prune-medium center p-1" width="85"><b>SIREN</b></td>
            <td class="prune-medium center p-1" width="60"><b>NIC</b></td>
            <td class="prune-medium p-1" width="600"><b>Nom du Site</b></td>
            <td class="prune-medium center p-1" width="75"><b>CntColl</b></td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(element, key) in anomalieNic" :key="key">
            <td class="center p-1"> {{ element.num_pm }}</td>
            <td class="center p-1"> {{ element.type_anomalie }}</td>
            <td class="center p-1"> {{ element.siren }}</td>
            <td class="center p-1"> {{ element.nic }}</td>
            <td class="p-1"> {{ element.raison_sociale }}</td>
            <td class="center p-1"> {{ element.precision }}</td>
          </tr>
          </tbody>
        </table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "AnomalieSirenNic",
    data() {
      return {
        anomalieSiren: [],
        anomalieNic: [],
        excelColumns: [
          {
            label: "NumPM",
            field: "num_pm",
          },
          {
            label: "Type Ano.",
            field: "type_ano",
          },
          {
            label: "SIREN",
            field: "siren",
          },
          {
            label: "NIC",
            field: "nic",
          },
          {
            label: "Nom du site",
            field: "raison_sociale",
          },
          {
            label: "Contrat Collectif",
            field: "CntColl",
          },
        ],
        excelDataSiren: [],
        excelDataNic: [],
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.downloadAnomalieSirenNic();
    },
    methods: {
      downloadAnomalieSirenNic() {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/extractions/anomalie_siren_nic')
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            this.anomalieSiren = response.data.data.anomalieSiren;
            for (let row of response.data.data.anomalieSiren) {
              this.excelDataSiren.push({
                num_pm: row.num_pm,
                type_ano: row.type_anomalie,
                siren: row.siren,
                nic: row.nic,
                raison_sociale: row.raison_sociale,
                CntColl: row.precision,
              });
            }
            this.anomalieNic = response.data.data.anomalieNic;
            for (let row of response.data.data.anomalieNic) {
              this.excelDataNic.push({
                num_pm: row.num_pm,
                type_ano: row.type_anomalie,
                siren: row.siren,
                nic: row.nic,
                raison_sociale: row.raison_sociale,
                CntColl: row.precision,
              });
            }
          })
          .catch(error => {
            self.$store.commit('IS_LOADING', false);
            console.log(error);
          });
      },
      getTimestamp() {
        let date = new Date;
        let day = date.getDate().toString().length === 1 ? '0' + date.getDate().toString() : date.getDate().toString();
        let month = (date.getMonth() + 1).toString().length === 1 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
        let year = date.getFullYear().toString();

        return day + '_' + month + '_' + year;
      },
    }
  }
</script>

<style scoped>

  .prune-medium {
    background-color: #C0504D;
    color: #FFFFFF;
  }

  .center {
    text-align: center;
  }
</style>
